import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authConfig: AuthConfig = {
    oidc: true,
    issuer: environment.authenticationUrl,
    customQueryParams: {
        organizationUUID: environment.organizationUUID,
        userType: 'SocogasManager@configuratorUser', //Tipo_UTENTE@Tipo_INTEGRAZIONE
        prompt: 'login',
    },
    requireHttps: environment.production,
    // clientId: 'merlo-integration', // The "Auth Code + PKCE" client
    clientId: 'socogas', // The "Auth Code + PKCE" client
    responseType: 'code',
    redirectUri: window.location.origin + '/index.html',
    logoutUrl: window.location.origin + '/index.html',
    scope: 'openid profile email offline_access', // Ask offline_access to support refresh token refreshes
    timeoutFactor: 0.75, // decrease this value for faster testing
    sessionChecksEnabled: false,
    showDebugInformation: !environment.production,
    clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
    nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by IdentityServer's URI encoding
    //senza non va l'auth
    openUri: (uri: string) => {
        location.href = uri;
    },
};

export const authModuleConfig: OAuthModuleConfig = {
    resourceServer: {
        allowedUrls: [],
        sendAccessToken: true,
    },
};
